"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findMraidEnvObject = exports.findMraidWindow = exports.isMraid1_0 = void 0;
const utils_1 = require("./utils");
function isMraid1_0(mraidObject) {
    const mraidMethods = [
        'addEventListener',
        // 'close',
        // 'expand',
        // 'getExpandProperties',
        // 'getPlacementType',
        'getState',
        // 'getVersion',
        // 'isViewable',
        // 'open',
        'removeEventListener'
        // 'setExpandProperties',
        // 'useCustomClose'
    ];
    return mraidMethods.every((method) => (0, utils_1.isFunction)(mraidObject[method]));
}
exports.isMraid1_0 = isMraid1_0;
function findMraidWindow(opt_window) {
    let windowObject = opt_window || window;
    while (windowObject) {
        try {
            if (windowObject.mraid && isMraid1_0(windowObject)) {
                return windowObject;
            }
        }
        catch (ignored) { }
        windowObject = windowObject === windowObject.parent ? null : windowObject.parent;
    }
    return null;
}
exports.findMraidWindow = findMraidWindow;
function findMraidEnvObject(opt_window) {
    let windowObject = opt_window || window;
    while (windowObject) {
        try {
            if (windowObject.MRAID_ENV) {
                return windowObject.MRAID_ENV;
            }
        }
        catch (ignored) { }
        windowObject = windowObject === windowObject.parent ? null : windowObject.parent;
    }
    return null;
}
exports.findMraidEnvObject = findMraidEnvObject;
//# sourceMappingURL=mraid-commons.js.map